<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>发布统计</span>
                        <span>发布结果统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <div style="position:relative;height:20px;">
                            <div class="helpDiv" style="position: absolute;top:-20px">
                                <b class="helpI"></b>
                                <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=26156944"
                                target="_blank"
                                class="helpA">
                                    帮助指引
                                </a>
                            </div>
                        </div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                            <el-button type="primary" @click="exportTable('发布结果统计',value[0],`—${value[1]}`)">导出excel</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table
                                :data="tableData"
                                show-summary
                                :summary-method="getSummaries" id="out_export">
                                <el-table-column width="80" prop="name" label="人员名称"></el-table-column>
                                <!--<el-table-column prop="deployCount" label="发布请求数量" sortable :sort-orders="sortList"></el-table-column>-->
                                <el-table-column prop="successCount" label="成功数量" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="failCount" label="失败数量" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="successRate" label="成功占比" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="failRate" label="失败占比" sortable :sort-orders="sortList"></el-table-column>
                            </el-table>
                        </div>
                        <div ref="myChart"></div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>{{getMes.generateTime}}</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from '../report.service';
    import { export_json_to_excel } from '../../../../core/utils/Export2Excel';
    export default {
        data: function () {
            return {
                tableData: [],
                sortList:['descending', 'ascending'],
                value:'',
                options:{
                    tooltip : {
                        formatter: function(params, ticket, callback){
                            if(params.seriesName == '成功占比' || params.seriesName == '失败占比'){
                                return params.seriesName+':'+params.data[params.seriesIndex+1] +'%';
                            }else{
                                return params.seriesName+':'+params.data[params.seriesIndex+1];
                            }
                        }
                    },
                    legend: {},
                    dataset:{},
                    dataZoom:[
                        {
                            type: 'inside',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'inside',
                            yAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            yAxisIndex: 0,
                        },
                    ],
                    xAxis: [{type: 'category',}],
                    yAxis: [{}],
                    series: [
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },

                        {
                            type:'bar',
                            label: {
                                normal: {
                                    formatter: function(params){
                                        return params.data[3]+'%';
                                    },
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    formatter: function(params){
                                        return params.data[4]+'%';
                                    },
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                    ]
                },
                getMes:{},
            }
        },
        mounted(){
            this.value = services.getDefaultData();
            this.getData();
        },
        methods:{
            exportTable(name,startTime,endTime=''){
                this.$exportTable(name,startTime,endTime)
            },
            getExcel(){
                let sendTableData = JSON.parse(JSON.stringify(this.tableData));
                // let deployCount = 0;
                let successCount = 0;
                let failCount = 0;
                let successRate = 0;
                let failRate = 0;
                this.tableData.forEach(res=>{
                    // deployCount += Number(res.deployCount);
                    successCount += Number(res.successCount);
                    failCount += Number(res.failCount);
                    successRate += Number(res.successRate);
                    failRate += Number(res.failRate);
                })
                sendTableData.push({name:'合计',successCount,failCount,successRate,failRate});
                let header = [];
                let filterVal = [];
                header = ['人员名称', '成功数量', '失败数量', '成功占比', '失败占比'];
                filterVal = ['name','successCount','failCount','successRate','failRate'];
                const list = sendTableData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel({header,data,filename:'发布结果统计'});
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            getData(){//获取数据
                let params = {
                    startTime: this.value[0],
                    stopTime: this.value[1],
                    group: 'deployManager'
                }
                services.getPublishRate(params).then(res=>{
                    res.tableData.forEach(item=>{
                        item.failRate =  Math.round(Number(item.failRate).toFixed(2)*100)+'%'
                        item.successRate =  Math.round(Number(item.successRate).toFixed(2)*100)+'%'
                    })
                    res.graphData.forEach(item=>{
                        if (item[0]!='product'){
                            item[3] =(Number(item[3])*100).toFixed(0)
                            item[4] =(Number(item[4])*100).toFixed(0);
                        }

                    })
                    this.getMes = res;
                    this.tableData = res.tableData;
                    this.getEcharts();
                })
            },
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                this.getData();
            },
            getEcharts(item){//实例化图标
                let myChart = this.$echarts.init(this.$refs.myChart);
                // 转化数据里面的小数
                // this.getMes.graphData = services.changeNum(this.getMes.graphData,4,5);
                this.options.dataset.source = this.getMes.graphData;
                myChart.setOption(this.options);
            },
            //处理表格合计行的百分比数据
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];       //sums数组里的每一项对应合计行的每一列
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                });
                // console.log(sums);
                if (sums[1]==0&&sums[2]==0){
                    sums[3]=0+'%'
                    sums[4]=0+'%'
                } else{
                    sums[3]=((sums[1]/(sums[1]+sums[2]))*100).toFixed(0)+'%'
                    sums[4]=((sums[2]/(sums[1]+sums[2]))*100).toFixed(0)+'%'
                }
                return sums;
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .tableClass{
        display: flex;
        &>div:nth-child(1){
            width: 45%;
        }
        &>div:nth-child(2){
            width: 55%;
            height:400px;
        }
    }
</style>
